import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Engineering from "./sections/Engineering";
import Wizard from "./sections/Wizard";
import Capabilities from "./sections/Capabilities";
import Metrics from "./sections/Metrics";
import Reports from "./sections/Reports";
import Intelligence from "./sections/Intelligence";
import Initiate from "./sections/Initiate";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Engineering />
      <Wizard />
      <Capabilities />
      <Metrics />
      <Reports />
      <Intelligence />
      <Initiate />
      <Footer />
    </div>;
}